import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import configureStore from 'store'
import { CookiesProvider } from 'react-cookie'
import { Provider } from 'react-redux'
import './components/assets/style/main.scss';
import { authConfig } from 'constants/config';

const store = configureStore({})

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <CookiesProvider>
  <BrowserRouter basename={authConfig.CONTEXT_PATH}>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
</CookiesProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
